import { ActionIcon, Flex, Text } from "@mantine/core";
import React, { useState } from "react";
import { TickIcon } from "../../assets";
import type { ExpertAssistMessage } from "../../shared-types";
import classes from "./Feedback.module.css";
import FeedbackIcons from "./FeedbackIcons";

interface FeedbackProps {
    message: ExpertAssistMessage | undefined;
}
export function Feedback({ message }: FeedbackProps) {
    const [isFeedbackClicked, setIsFeedbackClicked] = useState(false);

    const handleFeedbackClick = () => {
        setIsFeedbackClicked(true);
    };

    return (
        <>
            {isFeedbackClicked ? (
                <Flex className={classes.animate}>
                    <Text size="14px" pr="xxs">
                        Thanks for your feedback!
                    </Text>
                    <TickIcon />
                </Flex>
            ) : (
                <Flex className={classes.wrapper}>
                    <ActionIcon variant="transparent" w="2rem" h="2rem">
                        <FeedbackIcons onFeedbackClick={handleFeedbackClick} animationType="up" message={message} />
                    </ActionIcon>
                    <ActionIcon variant="transparent" w="2rem" h="2rem">
                        <FeedbackIcons onFeedbackClick={handleFeedbackClick} animationType="down" message={message} />
                    </ActionIcon>
                </Flex>
            )}
        </>
    );
}
export default Feedback;
